"use strict";

var _errorMessageService = require("../services/error-message.service.js");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PvdSystemMessage =
/*#__PURE__*/
function (_HTMLElement) {
  _inherits(PvdSystemMessage, _HTMLElement);

  _createClass(PvdSystemMessage, [{
    key: "template",
    value: function template() {
      var templateEl = document.createElement('template');
      templateEl.innerHTML = "\n        <!-- Start Style --><style>:host{display:block;position:relative}.message__inline{display:grid;display:-ms-grid;grid-template-columns:1em calc(100% - 1em);-ms-grid-columns:1em calc(100% - 1em)}.message__inline .message__content{padding-left:0.5em;display:flex;align-items:center}.message__inline pvd-icon{width:1rem;height:1rem}.message__inline .message__icon{display:flex;align-items:flex-start}.message__inline p.message__bind{font-size:0.75em;margin-top:0;padding-top:0}.message__inline.message__alert pvd-icon{fill:#E01616}.message__inline.message__alert p.message__bind{color:#E01616}.message__inline.message__info pvd-icon{fill:#6792af}.message__inline.message__warning pvd-icon{fill:#FFCD00}.message__inline.message__confirm pvd-icon{fill:#568200}.message__page,.message__global{position:relative;display:grid;display:-ms-grid;grid-template-columns:3.125em calc(100% - 3.125em);-ms-grid-columns:3.125em calc(100% - 3.125em);line-height:1.5em;margin-top:1em;background-color:#fff}.message__page.system-message-dismissible .message__content,.message__global.system-message-dismissible .message__content{padding-right:2.5em}.message__page.animateOut,.message__global.animateOut{animation:slide-up 0.5s ease-in-out}.message__page .dismissible-close,.message__global .dismissible-close{position:absolute;top:0.5em;right:0.5em;line-height:0.5em;z-index:10000000;padding:0.25em;text-decoration:none;margin:0;background:transparent;font-size:1em;border:none;cursor:pointer}.message__page .dismissible-close pvd-icon,.message__global .dismissible-close pvd-icon{fill:#999}.message__page .dismissible-close:focus,.message__page .dismissible-close:active,.message__global .dismissible-close:focus,.message__global .dismissible-close:active{outline:dotted 1px #000;border:none;box-shadow:none;transition:border 0.15s ease-in-out}.message__page .dismissible-close:not(:focus):hover,.message__global .dismissible-close:not(:focus):hover{border-color:#000}.message__page .message__icon,.message__global .message__icon{display:flex;justify-content:center;align-items:center}.message__page .message__icon pvd-icon,.message__global .message__icon pvd-icon{width:1em;height:1em;fill:#fff}.message__page .message__content,.message__global .message__content{padding:0.5em 1em}.message__page .message__content p.message__bind,.message__global .message__content p.message__bind{font-size:.875em}@media screen and (min-width: 32em){.message__page .message__content p.message__bind,.message__global .message__content p.message__bind{font-size:1em}}@media screen and (min-width: 60em){.message__page .message__content p.message__bind,.message__global .message__content p.message__bind{font-size:1.125em}}.message__page.message__confirm,.message__global.message__confirm{border-color:#568200}.message__page.message__confirm .message__icon,.message__global.message__confirm .message__icon{background-color:#568200}.message__page.message__alert,.message__global.message__alert{border-color:#E01616}.message__page.message__alert .message__icon,.message__global.message__alert .message__icon{background-color:#E01616}.message__page.message__info,.message__global.message__info{border-color:#6792af}.message__page.message__info .message__icon,.message__global.message__info .message__icon{background-color:#6792af}.message__page.message__warning,.message__global.message__warning{border-color:#FFCD00}.message__page.message__warning .message__icon,.message__global.message__warning .message__icon{background-color:#FFCD00}.message__page.message__warning .message__icon pvd-icon,.message__global.message__warning .message__icon pvd-icon{fill:#000}.message__page{border-radius:0.1875em;border-width:2px;border-style:solid;border-left:none}.message__page.message__alert .message__content p.message__bind{color:#E01616}.message__global{border:none}.message__global .message__content{border-bottom:1px solid #ccc}.message__inline .message__icon,.message__global .message__icon,.message__page .message__icon{grid-column:1;-ms-grid-column:1}.message__inline .message__content,.message__global .message__content,.message__page .message__content{grid-column:2;-ms-grid-column:2}.message__inline .message__content p.message__bind,.message__global .message__content p.message__bind,.message__page .message__content p.message__bind{margin:0;padding:0}@media (min-width: 32em){.message__page .message__content,.message__global .message__content{padding:1em}}@media (min-width: 60em){.message__global .message__icon pvd-icon,.message__page .message__icon pvd-icon{width:1.5em;height:1.5em}}@supports not (display: grid){.message__inline,.message__page,.message__global{display:flex;flex-direction:row;flex-basis:100%}.message__inline .message__icon,.message__page .message__icon,.message__global .message__icon{flex-direction:column;flex-basis:auto;flex-grow:0;flex-shrink:0}.message__inline .message__content,.message__page .message__content,.message__global .message__content{flex-direction:column;flex-basis:auto;flex-grow:1;flex-shrink:1}.message__page .message__icon,.message__global .message__icon{padding:0 0.75em}}@-webkit-keyframes slide-up{0%{opacity:1}100%{opacity:0}}@-moz-keyframes slide-up{0%{opacity:1}100%{opacity:0}}@-o-keyframes slide-up{0%{opacity:1}100%{opacity:0}}@keyframes slide-up{0%{opacity:1}100%{opacity:0}}\n</style><!-- End Style -->\n        <div class=\"message-container\">\n            <div class=\"message__icon\"></div>\n            <div class=\"message__content\">\n                <p class=\"message__bind\"></p>\n                <slot></slot>\n            </div>\n        </div>\n    ";
      return templateEl.content;
    }
  }, {
    key: "placement",
    get: function get() {
      return this.getAttribute("placement");
    },
    set: function set(val) {
      this.setAttribute("placement", val);
    }
  }, {
    key: "type",
    get: function get() {
      return this.getAttribute("type");
    },
    set: function set(val) {
      this.setAttribute("type", val);
    }
  }, {
    key: "message",
    get: function get() {
      return this.getAttribute("message");
    },
    set: function set(val) {
      this.setAttribute("message", val);
    }
  }, {
    key: "dismissible",
    get: function get() {
      return this.getAttribute("dismissible");
    },
    set: function set(val) {
      this.setAttribute("dismissible", val);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['message', 'placement', 'type', 'dismissible', 'error'];
    }
  }]);

  function PvdSystemMessage() {
    var _this;

    _classCallCheck(this, PvdSystemMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PvdSystemMessage).call(this));

    _this.attachShadow({
      mode: "open"
    }).appendChild(_this.template().cloneNode(true));

    _this._message;
    _this._placement;
    _this._type;
    _this._dismissible;
    _this.errorMessages = new _errorMessageService.ErrorMessageService();
    return _this;
  }

  _createClass(PvdSystemMessage, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.getAttribute('id')) {
        var uid = String('system-message-' + Date.now() + Math.floor(Math.random() * 1000));
        this.setAttribute('id', uid);
      }
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage(e, parent) {
      var _this2 = this;

      var tag = e.target.tagName;

      if (tag == 'PVD-ICON') {
        e.target.parentNode.parentNode.classList.add('animateOut');
      } else {
        e.target.parentNode.classList.add('animateOut');
      }

      setTimeout(function () {
        parent.parentNode.removeChild(parent);
        var dismissEvent = new CustomEvent('system-message-dismissed', {
          detail: _this2.getAttribute('id')
        });
        document.dispatchEvent(dismissEvent);
      }, 450);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      var _this3 = this;

      if (oldValue === newValue) return;
      var messageIcon = this.shadowRoot.querySelector(".message__icon");
      var messageContent = this.shadowRoot.querySelector(".message__content .message__bind");
      var messageContainer = this.shadowRoot.querySelector(".message-container");

      switch (name) {
        case 'placement':
          this._placement = newValue;

          if (oldValue && oldValue.length && messageContainer.classList.contains("message__" + oldValue)) {
            messageContainer.classList.remove("message__" + oldValue);
          }

          messageContainer.classList.add("message__" + this._placement);
          break;

        case "type":
          this._type = newValue;

          if (oldValue && oldValue.length && messageContainer.classList.contains("message__" + oldValue)) {
            messageContainer.classList.remove("message__" + oldValue);
          }

          messageContainer.classList.add("message__" + this._type);
          break;

        case "message":
          this._message = newValue;
          messageContent.innerHTML = this._message;
          break;

        case "dismissible":
          if (newValue && newValue == 'true' && this._placement != 'inline') {
            var dismissButton = document.createElement('button');
            dismissButton.setAttribute('type', 'button');
            dismissButton.setAttribute('aria-label', 'Close');
            dismissButton.className = 'dismissible-close';
            var closeIcon = document.createElement('pvd-icon');
            closeIcon.setAttribute('icon', 'close');
            closeIcon.setAttribute('aria-hidden', 'true');
            closeIcon.setAttribute('tabindex', '-1');
            dismissButton.appendChild(closeIcon);
            this.shadowRoot.querySelector('.message-container').appendChild(dismissButton);
            this.shadowRoot.querySelector('.message-container').classList.add('system-message-dismissible');
            this.shadowRoot.querySelector('.dismissible-close').addEventListener("click", function (e) {
              _this3.dismissMessage(e, _this3);
            });
          }

          break;

        case "error":
          this.setAttribute("message", this.errorMessages.getErrorMessage(newValue));
          break;
      }

      if (this._placement == "page" || this._placement == "global") {
        if (this._type == "warning" || this._type == "alert") {
          messageContainer.setAttribute("role", "alert");
          messageContainer.setAttribute("aria-live", "assertive");
        } else {
          if (messageContainer.hasAttribute("role")) {
            messageContainer.removeAttribute("role");
          }

          messageContainer.setAttribute("aria-live", "polite");
        }
      } else {
        if (messageContainer.hasAttribute("role")) {
          messageContainer.removeAttribute("role");
        }

        messageContainer.setAttribute("aria-live", "polite");
      }

      if (name == "type" || name == "placement") {
        this._messageType();
      }
    }
  }, {
    key: "_messageType",
    value: function _messageType() {
      if (this.placement === 'inline') {
        switch (this.type) {
          case "info":
          default:
            this.icon = 'info';
            break;

          case "confirm":
            this.icon = 'confirmation';
            break;

          case "warning":
          case "alert":
            this.icon = 'alert';
            break;
        }
      }

      if (this.placement === 'page' || this.placement === 'global') {
        switch (this.type) {
          case "info":
          default:
            this.icon = 'info-outline';
            break;

          case "confirm":
            this.icon = 'confirmation-outline';
            break;

          case "warning":
          case "alert":
            this.icon = 'alert-outline';
            break;
        }
      }

      var messageIcon = this.shadowRoot.querySelector(".message__icon");
      messageIcon.innerHTML = '<pvd-icon icon="' + this.icon + '" aria-hidden="true"></pvd-icon>';
    }
  }]);

  return PvdSystemMessage;
}(_wrapNativeSuper(HTMLElement));

if (!!customElements.get('pvd-system-message') == false) {
  customElements.define("pvd-system-message", PvdSystemMessage);
}